var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { patchInspectionSystem } from '../services/AnswersByTypeService';
import { answersByTypeKeys } from './queryKeys';
const namespace = 'features.inspections_answer_by_type';
export function useToggleSubcontractor(inspectionId) {
    const queryClient = useQueryClient();
    const queryKey = answersByTypeKeys.inspection(inspectionId);
    return useMutation({
        mutationFn: ({ inspectionSystemId, completedBySubcontractor }) => patchInspectionSystem(inspectionId, inspectionSystemId, completedBySubcontractor),
        onMutate: (_a) => __awaiter(this, [_a], void 0, function* ({ inspectionSystemId, completedBySubcontractor }) {
            yield queryClient.cancelQueries({ queryKey });
            const previous = queryClient.getQueryData(queryKey);
            queryClient.setQueryData(queryKey, (old) => old === null || old === void 0 ? void 0 : old.map((row) => row.inspection_system_id === inspectionSystemId
                ? Object.assign(Object.assign({}, row), { completed_by_subcontractor: completedBySubcontractor }) : row));
            return { previous };
        }),
        onSuccess: (_data, { completedBySubcontractor }) => {
            toast.success(completedBySubcontractor
                ? translate('toggle.success_marked', { namespace })
                : translate('toggle.success_restored', { namespace }));
        },
        onError: (_err, _vars, context) => {
            if (context === null || context === void 0 ? void 0 : context.previous) {
                queryClient.setQueryData(queryKey, context.previous);
            }
            toast.error(translate('toggle.error', { namespace }));
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey });
        }
    });
}
